// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'

// Internal Dependencies:
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import HeaderPrimary from 'components/HeaderPrimary/HeaderPrimary'
import HeaderMobilePrimary from 'components/HeaderPrimary/HeaderMobilePrimary'
import PageHeader from 'components/PageHeader/PageHeader'
import HomeContent from 'views/main/home/HomeContent'
import Footer from 'components/Footer/Footer'
import Locale from 'views/main/page/Locale'

const siteImage = siteData.featured_image_url
const siteImageSrcset = siteData.featured_image_srcset

// Redux:
import { getPageData } from 'actions/page'

class PageLayout extends React.Component {
	componentDidMount() {
		this.props.getPost( 'home', 'page' )

		window.scrollTo( 0, 0 )

		// Add class to html when scrolled to the top:

		// document.documentElement.classList.add( 'with-scroll-top' )

		// // Test via a getter in the options object to see if the passive property is accessed
		// this.supportsPassive = false

		// try {
		// 	var options = Object.defineProperty( {}, 'passive', {
		// 		get: () => {
		// 			this.supportsPassive = true
		// 		}
		// 	})

		// 	window.addEventListener( 'test', null, options )
		// 	window.removeEventListener( 'test', null, options )
		// } catch( err ) {}

		// // Listen for editor events:
		// window.addEventListener( 'scroll', this.handleScroll, this.supportsPassive ? { passive: true } : false )
	}

	componentWillUnmount() {
		window.removeEventListener( 'scroll', this.handleScroll )
	}

	// handleScroll = () => {
	// 	let top  = window.pageYOffset || document.documentElement.scrollTop

	// 	if ( 300 > top ) {
	// 		requestAnimationFrame( () => {
	// 			document.documentElement.classList.add( 'with-scroll-top' )
	// 		})
	// 	} else {
	// 		requestAnimationFrame( () => {
	// 			document.documentElement.classList.remove( 'with-scroll-top' )
	// 		})
	// 	}
	// }

	render() {
		let className = this.props.searchIsOpen ? 'with-search-open with-search-results-open is-home' : 'is-home'

		const localesRoutes = siteData.locales ? siteData.locales.map( e => {
			return <Route path={ '/' + e.slug + '/' } component={ Locale } key={ e.slug } />
		}) : null

		return (
			<div className={ className }>
				<HeaderMobilePrimary />

				<div className="main-wrap">
					<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />
					<HeaderPrimary />

					<PageHeader />

					<section className="main">
						<div className="main-inner">
							<div className="primary-wrap">
								<HomeContent />
							</div>
						</div>
					</section>
				</div>

				<Footer />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		searchIsOpen: state.search.isOpen
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getPost: ( slug, type, archivePageNumber ) => {
			dispatch( getPageData( slug, type, archivePageNumber ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( PageLayout )



// WEBPACK FOOTER //
// ./views/layouts/main/HomeLayout.jsx